import { type SxProps } from '@mui/material/styles';

export const styles = {
  headerOuter: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #eceff1',
  },
  header: {
    height: '66px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '144px',
    paddingRight: '144px',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    width: '280px',
  },
  logo: {
    height: '36px',
    width: '141px',
  },
  headerCenter: {
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
  },
  tab: {
    height: '66px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s',
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  tabActive: {
    borderBottom: '2px solid #19b5d2',
  },
  tabText: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    color: '#263238',
  },
  tabTextInactive: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    color: '#546e7a',
  },
  headerRight: {
    display: 'flex',
    gap: '11px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '280px',
  },
  userAvatar: {
    width: '36px',
    height: '36px',
  },
  userName: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.14px',
    color: '#263238',
  },
  userButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '4px 8px',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  menuPaper: {
    backgroundColor: '#f2f4f5',
    background: '#f2f4f5',
    border: '1px solid #cfd8dc !important',
    borderRadius: '16px !important',
    boxShadow: '0px 0px 64px 0px rgba(25, 181, 210, 0.12) !important',
    marginTop: '8px',
    '& .MuiMenuItem-root': {
      color: '#263238',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      padding: '12px 16px',
      '&:hover': {
        backgroundColor: 'rgba(25, 181, 210, 0.08)',
      },
    },
  },
  menuCompany: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    padding: '12px 16px 8px',
    minWidth: '180px',
  },
  menuCompanyLabel: {
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: '#78909c',
  },
  menuCompanyName: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    color: '#263238',
    wordBreak: 'break-word',
  },
  menuCompanyLink: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    color: '#19b5d2',
    wordBreak: 'break-word',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  menuDivider: {
    borderColor: '#cfd8dc',
    marginX: '8px',
  },
} satisfies Record<string, SxProps>;
